import React from "react";
import "./styles.scss";
import Header from "../../components/header";
import bannerImage from "../../assets/images/confident-sportswoman-with-dumbbell-dark.jpg";
import blockImage from "../../assets/images/front-view-hands-pressing-buzzer.jpg";
import TransactionsImage from "../../assets/images/transactions.jpg";
import calenderImage from "../../assets/images/calender.jpg";
import USMImage from "../../assets/images/usm_management.jpg";
import MembershipImage from "../../assets/images/membership.jpg";
import TokenImage from "../../assets/images/drawing306.jpg";
import PauseImage from "../../assets/images/claudio-schwarz-YxywelymVuE-unsplash.jpg";
import InvoiceImage from "../../assets/images/invoice.jpg";
import MobileWebImage from "../../assets/images/cropped-back-view-photo-handsome-african-man-chatting.jpg";
import LanguageImage from "../../assets/images/different-language-speech-bubble-hello-concept.jpg";
import doorImage from "../../assets/images/close-up-fingerprint-reader.jpg";
import notificationImage from "../../assets/images/notifications.jpg";
import Footer from "../../components/footer";

const Features = () => {
  return (
    <div className="features-page">
      <Header />

      <section
        className="features-banner"
        style={{ backgroundImage: `url(${bannerImage})` }}
      >
        <div className="container">
          <h1>Features</h1>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={blockImage}
                alt="Block Expired Subscriptions"
                className="feature-image"
              />
            </div>
            <div className="col-md-6">
              <div className="feature-content">
                <h2>Block Expired Subscriptions</h2>
                <p>
                  Automatically manage access by blocking users with expired
                  subscriptions. Our system tracks subscription status in
                  real-time and restricts access when necessary, ensuring only
                  paying customers can use your services while maintaining
                  security and business integrity.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <img
                src={TransactionsImage}
                alt="Transaction Management"
                className="feature-image"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <div className="feature-content">
                <h2>Transaction Management</h2>
                <p>
                  Keep track of all financial transactions in one centralized
                  system. Monitor payments, refunds, and subscriptions with
                  ease. Generate financial reports, track revenue streams, and
                  maintain a comprehensive record of all monetary exchanges
                  within your organization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={calenderImage}
                alt="Attendance Management"
                className="feature-image"
              />
            </div>
            <div className="col-md-6">
              <div className="feature-content">
                <h2>Attendance Management</h2>
                <p>
                  Track and manage attendance for employees, members, or
                  students with precision. Our advanced system records check-ins
                  and check-outs, calculates hours, and generates comprehensive
                  attendance reports, helping you maintain accountability and
                  optimize workforce management.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <img
                src={USMImage}
                alt="USM Management"
                className="feature-image"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <div className="feature-content">
                <h2>USM Management</h2>
                <p>
                  Streamline your user service management with our comprehensive
                  USM tools. Manage user accounts, track service utilization,
                  and ensure quality service delivery across your organization
                  with robust monitoring and reporting capabilities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={MembershipImage}
                alt="Membership Management"
                className="feature-image"
              />
            </div>
            <div className="col-md-6">
              <div className="feature-content">
                <h2>Membership Management</h2>
                <p>
                  Efficiently manage all aspects of your membership program from
                  sign-up to renewal. Track member status, manage different
                  membership tiers, process renewals, and provide members with
                  self-service options to update their information and
                  preferences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <img
                src={TokenImage}
                alt="Token-Based Subscription"
                className="feature-image"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <div className="feature-content">
                <h2>Token-Based Subscription</h2>
                <p>
                  Implement flexible token-based subscription models for your
                  services. Allow customers to purchase and use tokens for
                  specific services or time periods, creating versatile payment
                  options that adapt to your business needs and customer
                  preferences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={PauseImage}
                alt="Hold/Resume Subscription"
                className="feature-image"
              />
            </div>
            <div className="col-md-6">
              <div className="feature-content">
                <h2>Hold/Resume Subscription</h2>
                <p>
                  Give your customers the flexibility to pause and resume their
                  subscriptions as needed. This user-friendly feature improves
                  customer satisfaction and retention by accommodating temporary
                  breaks while maintaining their account settings and
                  preferences.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <img
                src={InvoiceImage}
                alt="Invoice Generation"
                className="feature-image"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <div className="feature-content">
                <h2>Invoice Generation</h2>
                <p>
                  Create professional, customized invoices automatically with
                  our powerful invoicing system. Generate individual or batch
                  invoices, track payment status, and send reminders for overdue
                  payments, streamlining your billing processes and improving
                  cash flow.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={MobileWebImage}
                alt="Available on Mobile & Web"
                className="feature-image"
              />
            </div>
            <div className="col-md-6">
              <div className="feature-content">
                <h2>Available on Mobile & Web</h2>
                <p>
                  Access XENTRY BOOK anytime, anywhere with our seamless mobile
                  and web applications. Enjoy the same powerful features across
                  all devices, allowing you to manage your business on the go or
                  from your desktop with synchronized data and consistent user
                  experience.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <img
                src={LanguageImage}
                alt="Multi-Language Support"
                className="feature-image"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <div className="feature-content">
                <h2>Multi-Language Support</h2>
                <p>
                  Reach a global audience with our comprehensive multi-language
                  support. The platform automatically adapts to user language
                  preferences, making it accessible and user-friendly for
                  clients and employees worldwide, expanding your business
                  opportunities across language barriers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <img
                src={doorImage}
                alt="Door Access"
                className="feature-image"
              />
            </div>
            <div className="col-md-6">
              <div className="feature-content">
                <h2>Door Access</h2>
                <p>
                  Control physical access to your facilities with our integrated
                  door access system. Compatible with various access control
                  hardware, our solution allows you to manage entry permissions,
                  track access events, and enhance security across your premises
                  with digital authorization.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="feature-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6 order-md-2">
              <img
                src={notificationImage}
                alt="Notification & Alerts"
                className="feature-image"
              />
            </div>
            <div className="col-md-6 order-md-1">
              <div className="feature-content">
                <h2>Notification & Alerts</h2>
                <p>
                  Stay informed with our comprehensive notification system.
                  Receive real-time alerts for important events such as new
                  sign-ups, payment confirmations, subscription expirations, and
                  security incidents, ensuring you never miss critical
                  information about your business operations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Features;
